// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"Nav--next-sr-only--2ZLMroi","navs":"Nav--navs--2taalh9","navItem":"Nav--navItem--3vJMYKk","navItemActive":"Nav--navItemActive--31K2wsG"};